import { gql, type TypedDocumentNode } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { TaskCards } from './TaskCards';
import { TaskCollections } from './TaskCollections';
import type { TaskCardsOrCollections_taskInterface } from './__generated__/index.graphql';

type Props = {
  task: TaskCardsOrCollections_taskInterface;
};

export const TaskCardsOrCollections = ({ task }: Props) => {
  if (isType(task, 'CardsCountTargetTask')) {
    return <TaskCards task={task} />;
  }
  if (isType(task, 'CompleteCollectionsCountTargetTask')) {
    return <TaskCollections task={task} />;
  }
  return null;
};

TaskCardsOrCollections.fragments = {
  taskInterface: gql`
    fragment TaskCardsOrCollections_taskInterface on TaskInterface {
      id
      ...TaskCards_taskInterface
      ...TaskCollections_taskInterface
    }
    ${TaskCards.fragments.taskInterface}
    ${TaskCollections.fragments.taskInterface}
  ` as TypedDocumentNode<TaskCardsOrCollections_taskInterface>,
};
